import request from '@/utils/request'

export function userLogin(data) {
  return request({
    url: '/v3/user/userLogin',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/v3/user/userInfoV3',
    method: 'get',
    params: token
  })
}

export function logout() {
  return request({
    url: '/v3/user/logout',
    method: 'post'
  })
}

// 获取官网logo，表：cust_deployment
export function webInfo() {
  return request({
    url: '/v3/user/webInfo',
    method: 'get'
  })
}
